import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { BillsDueCardComponent } from './bills-due-card.component';
import { PipesModule } from '@1bill-app/pipes/pipes.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [BillsDueCardComponent],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule,
    PipesModule,
  ],
  exports: [BillsDueCardComponent],
  providers: [CurrencyPipe]
})
export class BillsDueCardComponentModule {}
